<template>
  <div v-if="data.items" class="links-downloads">
    <LinksGroup :links="data.items" />
  </div>
</template>

<script setup lang="ts">
import LinksGroup from '~/components/LinksGroup.vue'

defineProps<{
  data: any
}>()

</script>

<style lang="scss">
@use "~/assets/sass/tools";

.links-downloads {
  @include tools.page-grid-columns;
  display: flex;
  flex-direction: column;
  gap: var(--space--xs);
}
</style>
